import Vue from 'vue/dist/vue.esm'
import EditorModal from '../../components/editor_modal.vue'

var currentModal = null;

export default {
  show: (opts) => {
    const el = document.body.appendChild(document.createElement('div'))
    currentModal = new Vue({
      el,
      render: h => h(EditorModal, { props: opts }),
    })
    $("body").addClass("modal-open");
  },
  
  hide: () => {
    if(currentModal != null) {
      currentModal.$destroy();
      $(currentModal.$el).remove();
      currentModal = null;
    }
    $("body").removeClass("modal-open");
  }
};
